import { Record } from "immutable";
import { RecordUtils } from "@rsm-hcd/javascript-core";
import GroupMigrationRequestDto from "models/interfaces/group-migration-request";
import { CollectionUtils } from "utilities/collection-utils";
import GroupMemberRecord from "./group-member-record";

const defaultValues: GroupMigrationRequestDto =
    RecordUtils.defaultValuesFactory({
        sourceGroupId: undefined,
        targetGroupId: undefined,
        teamMembersToMove: [],
        teamMemberEmailsToInvite: [],
        status: undefined,
        jobId: undefined,
    });

export default class GroupMigrationRequestRecord
    extends Record(defaultValues)
    implements GroupMigrationRequestDto
{
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: GroupMigrationRequestDto) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (CollectionUtils.hasValues(params.teamMembersToMove)) {
            params.teamMembersToMove = params.teamMembersToMove?.map(
                (g: GroupMemberRecord) =>
                    RecordUtils.ensureRecord(g, GroupMemberRecord)
            );
        }

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    public isValid(): boolean {
        return this.sourceGroupId !== this.targetGroupId;
    }

    public with(
        values: Partial<GroupMigrationRequestDto>
    ): GroupMigrationRequestRecord {
        return new GroupMigrationRequestRecord(
            Object.assign(this.toJS(), values)
        );
    }

    // #endregion Public Methods
}
